/** Shared geometry for drawing, snapping, initial layouts and validation. */
export const rackSlots=[-64,-32,0,32,64] as const;
export const rackSlotPoint=(rack:{x:number;y:number},slot:number)=>({x:rack.x+rackSlots[slot],y:rack.y-9});
export const defaultTubeCapacityMl=10;
export function rackTubeCountError(kind:string,count:unknown){
 if(count===undefined)return;
 if(kind!=='test-tube-rack'||!Number.isInteger(count)||Number(count)<0||Number(count)>rackSlots.length)return `Choisissez de 0 à ${rackSlots.length} tubes pour le porte-tubes.`;
}
